import React, { useEffect } from "react";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import "./style.scss";
import "../../../style/feature.scss";
import "../../../style/typography.scss";
import "../../../style/block.scss";
import "../../../style/buttons.scss";
import "../../../style/forms.scss";
import "../../../style/alerts.scss";
import { useNavigate } from "react-router";
import { LOGIN_PAGE } from "../../routes";
import { SubmitHandler, useForm } from "react-hook-form";
import { emailValidator } from "../../../utils/formsValidation";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { REMIND_PASSWORD_USER_URL } from "../../api/apiRoutes";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, setSuccessMessage } from "../../store/alerts/alertsActions";
import FormInput from "../../../utils/FormInput";
import useFacility from "../../../utils/hooks/useFacility";
import { BiLogInCircle } from "react-icons/bi";
import { State } from "../../store";
import { useTranslation } from "react-i18next";

type Inputs = {
  email: string;
};

const RemindPass: React.FC = () => {
  const isDesktop = useDesktopSize();
  const navigate = useNavigate();
  const { post } = useApiRequest();
  const facilityIds = useFacility();
  const dispatch = useDispatch();
  const alertLogin = useSelector((state: State) => state.alerts.errors);
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();
  const handleRemindPass: SubmitHandler<Inputs> = async (data) => {
    const { isError } = await post(REMIND_PASSWORD_USER_URL(facilityIds), { email: data.email });
    if (!isError) {
      dispatch(setSuccessMessage(t("haslo_zostalo_wyslane_na_podany_adres_email")));
    }
  };

  useEffect(() => {
    dispatch(clearErrors());
    //eslint-disable-next-line
  }, []);

  return (
    <div className="remind-pass flex-center-center">
      <div className="box shadow border">
        <form onSubmit={handleSubmit(handleRemindPass)}>
          <h2 className="italic">{t("zapomnialem_hasla")}</h2>
          <p>{t("podaj_adres_email_podany_przy_rejestracji_na_ktory_zostanie_przeslane_nowe_haslo")}</p>
          <FormInput
            type={"text"}
            name={"email"}
            text={"E-mail"}
            register={{ ...register("email", { ...emailValidator(true) }) }}
            errors={errors}
          />

          {alertLogin && alertLogin.length > 0 && <div className="alert alert-red">{alertLogin}</div>}

          <div>
            <input className="button big button-fill-main full-button" type={"submit"} value={t("resetuj_haslo")} />
          </div>

          <button className="button big padding-big full-button button-text-main" onClick={() => navigate(LOGIN_PAGE)}>
            {t("zaloguj_sie")}
            <BiLogInCircle className="icon-second" />
          </button>
        </form>
      </div>
    </div>
  );
};

export default RemindPass;
